define([
	"dojo/_base/declare",
	"csi/action/SelectOneController",
	"csi/xml",
	"csi/xml/Query"
], function(declare,SelectOneController,xml,Query) {

	return declare(SelectOneController, {
		applyActionFilters: function(/*csi.view.Widget*/view) {
			// summary: apply fixed filters from action, if any; in this case, referenced view cannot
			// contain current parent if relation is the same
			if (!this.m_action.m_idRelation || (this.m_action.m_idRelation == this.m_idAttrParent)) {
				view.relRoot.addQuery(new Query().Node(xml.PROP_URL, xml.OP_NOT_EQUALS, this.m_urlParent));
			}

			this.inherited(arguments);
		},

		toWriter: function() {
			// summary: move node from one parent to another
			var idAttrNew = this.m_idRelation ? this.m_idRelation : this.m_idAttrParent;
			var urlNew = this.m_formData.getSelectedNode().$URL;

			// issue request if there is one - request will use changed parameters from above
			var call = this.inherited(arguments);
			if (call) {
				call.addParameter(xml.PROP_ATTR_ADD, xml.ATTR_STRING, idAttrNew);
			} else {
				// FIX - this does not handle "refmap" containers
				console.assert(!xml.attributeTypeIsMap(this.getParentAttributeType()));

				// remove node from where it currently is referenced
				if (this.m_urlParent) {
					this.m_writer.changeParent(this.m_urlParent, this.m_idAttrParent, xml.ATTR_REFLIST, [this.m_urlNode], false);
				}

				// attach to new node
				this.m_writer.changeNode(this.m_urlNode).attach(urlNew, idAttrNew);
			}

			return call;
		}
	});
});